import { Drawer as MuiDrawer, DrawerProps } from '@mui/material'
import clsx from 'clsx'
import { JSX } from 'react'

import { Button, ButtonProps } from '../button/button'

import styles from './styles.module.scss'

export const CloseDrawerButton = (props: ButtonProps) => (
  <Button {...props} className={styles.closeDrawerButton} />
)

export const Drawer = (props: DrawerProps) => (
  <MuiDrawer {...props} className={clsx(styles.drawer, props.className)} />
)

export const DrawerHeader = (props: JSX.IntrinsicElements['div']) => (
  <div className={styles.drawerHeader} {...props} />
)
